module.exports = {"341202001":"鼓楼街道","341202002":"文峰街道","341202003":"清河街道","341202004":"颍西街道","341202005":"西湖景区街道","341202100":"王店镇","341202101":"程集镇","341202102":"三合镇","341202103":"西湖镇","341202104":"九龙镇","341202105":"三十里铺镇","341202106":"三塔集镇","341202200":"马寨乡","341202400":"安徽颍州经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341202.json
// module id = 1227
// module chunks = 0